import React, { useState } from "react";
import "../media/css/portfolio.css";
import p1 from "../media/img/p1.jpg";
import p2 from "../media/img/p2.png";
import p3 from "../media/img/p3.png";
import p4 from "../media/img/p4.png";
import p5 from "../media/img/p5.png";
import p6 from "../media/img/p6.png";

const categories = ["All", "Web Design", "Animation", "Other"];

const portfolioItems = [
  {
    id: 1,
    image: p1,
    title: "Metaverse",
    category: "Graphic Design",
    date: "2023-08-15",
    link: "#",
  },
  {
    id: 2,
    image: p2,
    title: "DRTX",
    category: "UI/UX",
    date: "2023-06-20",
    link: "#",
  },
  {
    id: 3,
    image: p3,
    title: "VR Coggles",
    category: "Web Design",
    date: "2023-05-10",
    link: "#",
  },
  {
    id: 4,
    image: p4,
    title: "ERSACE",
    category: "Web Design",
    date: "2023-04-05",
    link: "#",
  },
  {
    id: 5,
    image: p5,
    title: "JELIY FISH",
    category: "Web Design",
    date: "2023-03-30",
    link: "#",
  },
  {
    id: 6,
    image: p6,
    title: "JUPITER",
    category: "Animation",
    date: "2023-02-25",
    link: "#",
  },
];

const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const [selectedItem, setSelectedItem] = useState(null);

  const filteredItems =
    activeCategory === "All"
      ? portfolioItems
      : portfolioItems.filter((item) => item.category === activeCategory);

  const openModal = (item) => {
    setSelectedItem(item);
  };

  const closeModal = () => {
    setSelectedItem(null);
  };

  return (
    <section id="portfolio" className="section-portfolio">
      <div className="layer"></div>
      <div className="container">
        <header className="header">
          <h2 className="title">PORTFOLIO</h2>
          <nav className="bookmarks">
            {categories.map((category) => (
              <button
                key={category}
                className={activeCategory === category ? "active" : ""}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </nav>
        </header>
        <div className="cards">
          {filteredItems.map((item) => (
            <button
              key={item.id}
              className="card"
              onClick={() => openModal(item)}
            >
              <img src={item.image} alt={item.title} />
              <div className="content">
                <p>{item.title}</p>
                <span>{item.category}</span>
              </div>
            </button>
          ))}
        </div>

        {/* Modal */}
        {selectedItem && (
          <div className="modal">
            <div className="modal-content">
              <button className="close-modal" onClick={closeModal}>
                <i className="bi bi-x-lg"></i>
              </button>
              <img
                src={selectedItem.image}
                alt={selectedItem.title}
                className="modal-image"
              />
              <div className="info">
                <h3 className="title">{selectedItem.title}</h3>
                <p className="category">{selectedItem.category}</p>
                <p className="date">{selectedItem.date}</p>
                <a
                  href={selectedItem.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Visit Project
                  <i className="bi bi-box-arrow-up-right"></i>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Portfolio;
